<template>
  <div class="bootstrap-vue">
    <label
      :class="getClassName"
      @click.stop.prevent="()=>{/* NoOp to prevent label click */}"
    >
      {{ label }}
      <span
        :class="jcPrettyToggle.floatingLabelWrapper"
        @click.stop.prevent="handleValueChange()"
      >
        <b-form-checkbox
          :checked="config.value"
          :disabled="disabled"
          name="jcPrettyToggle"
          switch
        >
          <div
            :class="[
              jcPrettyToggle.floatingLabel,
              floatingLabel.class,
            ]"
          >
            {{ floatingLabel.label }}
          </div>
        </b-form-checkbox>
      </span>
    </label>
  </div>
</template>
<script>
import { BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'PrettyToggle',

  components: {
    BFormCheckbox,
  },

  props: {
    config: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    handleToggleChange: {
      type: Function,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    labelFirst: {
      type: Boolean,
      default: false,
    },
    labelOff: {
      type: String,
      default: 'off',
    },
    labelOn: {
      type: String,
      default: 'on',
    },
  },

  computed: {
    floatingLabel() {
      const prettyToggleDom = {
        on: {
          class: this.jcPrettyToggle.labelOn,
          label: this.labelOn,
        },
        off: {
          class: this.jcPrettyToggle.labelOff,
          label: this.labelOff,
        },
      };

      return this.config.value
        ? prettyToggleDom.on
        : prettyToggleDom.off;
    },

    getClassName() {
      return [
        this.jcPrettyToggle.toggle,
        this.jcPrettyToggle.label,
        { [this.jcPrettyToggle.reverseToggle]: this.labelFirst },
      ];
    },
  },

  methods: {
    handleValueChange() {
      const newValue = !this.config.value;
      this.config.value = newValue;
      return this.handleToggleChange(newValue);
    },
  },
};
</script>

<style module="jcPrettyToggle">
@import '../../components/PrettyToggle/PrettyToggle.css';

.toggle label {
  cursor: pointer;
}

.reverseToggle {
  flex-direction: row-reverse;
  width: fit-content;
}

.reverseToggle.label > .floatingLabelWrapper {
  margin: 0 10px 0 0;
}
</style>
